module.exports = {
  src: __webpack_public_path__ + "logo-webshop-award-c94b3f6f5e10e8096ca3e8fcc999e33c.svg",
  width: 60,
  height: 102,
  bytes: 120561,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "logo-webshop-award-c94b3f6f5e10e8096ca3e8fcc999e33c.svg";
};